import { Box } from "@mui/material";
import { memo, useEffect, useState } from "react";

import "./styles.css";

function Coinflip({ mustStartSpinning, prizeNumber, onRoll }) {
  const [result, setResult] = useState("");
  const [display, setDisplay] = useState("heads");

  useEffect(() => {
    if (mustStartSpinning && !result) {
      const prizeSide = Number(prizeNumber) === 1 ? "heads" : "tails";
      // const prizeReverseSide = prizeSide === "heads" ? "tails" : "heads";
      setDisplay("");
      setResult(prizeSide);
      setTimeout(() => {
        setDisplay(prizeSide);
        setResult("");
        onRoll();
      }, 1900);
    }
  }, [mustStartSpinning, prizeNumber, result, onRoll]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      {display ? (
        <img style={{display:"block"}} src={`/img/${display}.svg`} width="100px" />
      ) : (
        <div id="coin" className={result} key={+new Date()}>
          <div className="side-a">{/* <span>HEADS</span> */}</div>
          <div className="side-b">{/* <span>TAIL</span> */}</div>
        </div>
      )}
    </Box>
  );
}

export default Coinflip;
